import { render, staticRenderFns } from "./AssignApwPlan.vue?vue&type=template&id=494d82d6&scoped=true&"
import script from "./AssignApwPlan.vue?vue&type=script&lang=js&"
export * from "./AssignApwPlan.vue?vue&type=script&lang=js&"
import style0 from "./AssignApwPlan.vue?vue&type=style&index=0&id=494d82d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d82d6",
  null
  
)

export default component.exports